<template>
  <div
    class="rounded-lg"
    :class="paymentOption === 'INVOICE' ? 'option-active' : 'option-deactive'"
    @click="selectPayment('INVOICE')"
  >
    <v-row class="py-6 pt-7 px-6" no-gutters align="center">
      <v-icon>mdi-currency-usd</v-icon>
      <v-col class="pl-8">
        <v-row no-gutters>
          <span class="accent--text">Venda Faturada</span>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-radio-group class="pa-0 ma-0" hide-details :value="paymentOption">
        <v-radio color="primary" id="INVOICE" value="INVOICE"></v-radio>
      </v-radio-group>
    </v-row>
    <div class="px-4 py-4" v-if="paymentOption === 'INVOICE'">
      <v-btn
        v-if="!loading"
        width="100%"
        rounded
        depressed
        height="40"
        color="primary"
        :disabled="!canPurchase || !paymentOption"
        :loading="loading"
        @click="$emit('purchase')"
        >{{ $t("cart.continue") }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["loading"],
  computed: {
    ...mapGetters(["paymentOption", "canPurchase"]),
  },
  methods: {
    selectPayment(invoice) {
      this.$store.dispatch("setPaymentOption", invoice);
    },
  },
};
</script>
